import { render, staticRenderFns } from "./interfaceLog.vue?vue&type=template&id=4dcdffe9&"
import script from "./interfaceLog.vue?vue&type=script&lang=js&"
export * from "./interfaceLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports